import { configureStore } from '@reduxjs/toolkit';
import { selectionReducer } from '../selection/redux/selectionSlice';
import { rowRegistryReducer } from '../table/redux/rowRegistrySlice';
export const createSelectionStore = () => configureStore({
  reducer: {
    selection: selectionReducer,
    rowRegistry: rowRegistryReducer
  },
  devTools: {
    name: 'customer-data-table-selection'
  }
});